import { render, staticRenderFns } from "./RiskProblem.vue?vue&type=template&id=0d57f186&scoped=true"
import script from "./RiskProblem.vue?vue&type=script&lang=js"
export * from "./RiskProblem.vue?vue&type=script&lang=js"
import style0 from "./RiskProblem.vue?vue&type=style&index=0&id=0d57f186&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57f186",
  null
  
)

export default component.exports